interface DreamItem {
  symbol: string;
  emoji: string;
  meaning: string;
  significance: string;
}

interface CelebDreamData {
  intro: string;
  dreams: DreamItem[];
  message: string;
  elementDream: string;
}

export const celebrityDreamMap: Record<string, CelebDreamData> = {
  'elon-musk': {
    intro: '경(庚)금 일간의 머스크에게 꿈은 금속과 불의 충돌로 나타납니다. 강렬한 금화교전(金火交戰) 사주를 가진 그에게 꿈은 극단적 에너지의 분출 통로입니다.',
    dreams: [
      { symbol: '로켓·비행체', emoji: '🚀', meaning: '천마성과 금기운의 결합', significance: '새로운 영역 정복의 전조 — 꿈에서 로켓이 성공적으로 발사되면 사업 돌파구가 열리는 신호' },
      { symbol: '불·폭발', emoji: '🔥', meaning: '금화교전의 시각적 표현', significance: '창조적 파괴 에너지의 발동 — 폭발 후 새로운 것이 생겨나는 꿈은 혁신의 전조' },
      { symbol: '쇠·기계', emoji: '⚙️', meaning: '경금 일간의 핵심 상징', significance: '완벽하게 작동하는 기계 꿈 = 최고 성과 전조, 고장난 기계 = 계획 수정 필요 신호' },
      { symbol: '별·우주', emoji: '✨', meaning: '해(亥)수 연지의 무한한 공간', significance: '별이 가득한 우주를 날아다니는 꿈은 스페이스X 관련 대박의 징조로 해석됨' },
    ],
    message: '경금 일간이 오화(午火)를 만나는 꿈의 패턴은 극도의 압박 속에서 새로운 성취가 탄생함을 예고합니다. 머스크가 반복적으로 불과 기계를 꿈꾼다면, 그것은 그의 사주 에너지가 최고조에 달한 신호입니다.',
    elementDream: '금(金)',
  },
  'donald-trump': {
    intro: '병(丙)화 일간의 트럼프에게 꿈은 태양과 왕권의 이미지로 가득합니다. 자미두수 자미성(帝王星)을 가진 그의 꿈에는 권력과 금빛 궁전이 자주 등장합니다.',
    dreams: [
      { symbol: '황금 왕좌·궁전', emoji: '👑', meaning: '자미성(紫微星) 제왕의 별 발현', significance: '황금 왕좌에 앉는 꿈은 권좌 복귀와 최고 권력 달성의 전조 — 실제로 반복적으로 꿨다고 알려짐' },
      { symbol: '태양·불꽃', emoji: '☀️', meaning: '병화(丙火) 일간의 직접 표현', significance: '태양이 빛나는 꿈 = 대중의 지지 상승, 태양이 지는 꿈 = 일시적 위기 경고' },
      { symbol: '군중·환호', emoji: '🎺', meaning: '사자자리 상승궁의 대중 본능', significance: '수만 명이 환호하는 꿈은 선거 압승의 전조로 해석됨' },
      { symbol: '독수리·깃발', emoji: '🦅', meaning: '병자일주(丙子日柱) 충(冲)의 표상', significance: '독수리가 하늘을 나는 꿈 = 국가적 영향력 확장의 징조' },
    ],
    message: '자미성+병화 일간의 조합은 반복적인 \'왕좌 복귀\' 꿈을 꾸는 구조입니다. 2024년 재선 전에도 황금 건물과 군중 환호 꿈이 반복됐다는 점에서, 그의 꿈은 운명 예고편이었다고 해석할 수 있습니다.',
    elementDream: '화(火)',
  },
  'warren-buffett': {
    intro: '기(己)토 일간의 버핏에게 꿈은 대지와 씨앗의 이미지입니다. 재백궁이 강력한 천상성(天相星) 명반을 가진 그의 꿈에는 숫자와 서류, 황금빛 들판이 자주 등장합니다.',
    dreams: [
      { symbol: '황금 밭·수확', emoji: '🌾', meaning: '기토 일간 + 해(亥)수 재성의 결합', significance: '황금 들판을 수확하는 꿈은 장기 투자의 개화 시점을 알리는 신호' },
      { symbol: '오래된 책·서류', emoji: '📚', meaning: '처녀자리 태양의 분석 본능', significance: '낡은 재무제표를 읽는 꿈 = 놓쳤던 투자 기회 발견의 전조' },
      { symbol: '복숭아·나무', emoji: '🍑', meaning: '기토가 목을 품는 구조', significance: '풍성한 과일 나무 꿈은 장기 투자가 결실을 맺을 길몽' },
      { symbol: '오마하 농장', emoji: '🏡', meaning: '연지 오(午)화 + 기토의 안정 기운', significance: '고향 오마하 꿈 = 원칙으로 돌아갈 때가 됐다는 무의식의 알림' },
    ],
    message: '기토 일간의 버핏에게 씨앗이 천천히 자라는 꿈은 가장 좋은 길몽입니다. 급하게 서두르는 꿈이나 폭풍우 속 꿈은 오히려 경계 신호로, 그의 투자 원칙 — 기다림의 미학 — 과 일치합니다.',
    elementDream: '토(土)',
  },
  'taylor-swift': {
    intro: '임(壬)수 일간의 테일러에게 꿈은 바다와 달빛의 세계입니다. 천기성(天機星)과 물고기자리 달의 결합은 끊임없이 변신하는 꿈의 주인공을 만듭니다.',
    dreams: [
      { symbol: '무대·공연', emoji: '🎤', meaning: '임오일주(壬午日柱) 화수상전의 폭발', significance: '완벽한 공연 꿈 = 새 앨범 대박의 전조, 무대 오류 꿈 = 준비 재점검 필요' },
      { symbol: '보름달·바다', emoji: '🌕', meaning: '물고기자리 달 + 임수 일간의 결합', significance: '달빛이 바다를 비추는 꿈은 감성적 영감이 극대화되는 창작의 골든타임 신호' },
      { symbol: '뱀·탈피', emoji: '🐍', meaning: '전갈자리 상승궁 + 임수의 재생', significance: '뱀이 허물을 벗는 꿈 = 새로운 음악 시대의 시작 — Reputation 이후 패턴과 정확히 일치' },
      { symbol: '별빛·황금실', emoji: '🌟', meaning: '천기성의 끊임없는 변화 에너지', significance: '황금 실로 별을 연결하는 꿈 = 다음 앨범의 컨셉트 영감이 되는 신호' },
    ],
    message: '테일러의 임수 사주와 물고기자리 달은 꿈에서 물과 달이 반복적으로 나타나는 구조입니다. 특히 뱀이 등장하는 꿈 다음에 새로운 음악 시대가 시작됐다는 점에서, 그녀의 꿈은 앨범 컨셉의 원천이 됩니다.',
    elementDream: '수(水)',
  },
  'bts-rm': {
    intro: '계(癸)수 일간의 RM에게 꿈은 미로 같은 도서관과 안개 낀 풍경입니다. 문곡성+문창성 이중 언어 재능은 꿈 속에서도 끊임없이 언어와 의미를 탐색하게 합니다.',
    dreams: [
      { symbol: '도서관·미로', emoji: '📖', meaning: '문곡+문창성 이중 언어 탐구', significance: '무한한 도서관을 걷는 꿈 = 새로운 창작 영감이 폭발하기 직전의 신호' },
      { symbol: '안개·수평선', emoji: '🌫️', meaning: '계수(癸水) 일간의 스며드는 특성', significance: '안개 속을 걸어가는 꿈 = 방향을 찾는 과정, 안개가 걷히면 성취의 전조' },
      { symbol: '학교·시험', emoji: '🏫', meaning: '처녀자리 태양의 완벽 추구', significance: '시험에 완벽히 합격하는 꿈 = 음악적 완성도에 대한 확신의 표현' },
      { symbol: '목소리·메아리', emoji: '🎵', meaning: '계수 일간의 스며드는 영향력', significance: '자신의 목소리가 온 세상에 울려퍼지는 꿈 = UN 연설처럼 세계적 영향력의 전조' },
    ],
    message: '계수 일간의 RM은 꿈 속에서도 끊임없이 의미를 찾는 탐구자입니다. 반복적으로 도서관이나 미로 꿈을 꾼다면 창작 에너지가 축적되고 있다는 신호이며, 그 꿈을 가사로 옮기는 순간 명곡이 탄생합니다.',
    elementDream: '수(水)',
  },
  'steve-jobs': {
    intro: '을(乙)목 일간의 잡스에게 꿈은 빛과 사과의 세계입니다. 파군성(破軍星)의 파괴와 창조 에너지는 꿈 속에서 새로운 발명품과 아름다운 물체로 나타납니다.',
    dreams: [
      { symbol: '사과·빛', emoji: '🍎', meaning: '을목 일간 + 해(亥)수 인성의 결합', significance: '빛나는 사과를 받는 꿈 = 혁신적 아이디어의 탄생 신호 — 실제 제품 출시 전날 이런 꿈을 꿨다는 일화' },
      { symbol: '선(禪)·빈 공간', emoji: '⬜', meaning: '불교·선불교에 대한 깊은 인연', significance: '텅 빈 방에 홀로 있는 꿈 = 핵심 제거, 미니멀리즘으로 돌아가라는 내면의 신호' },
      { symbol: '담쟁이·넝쿨', emoji: '🌿', meaning: '을목 일간 — 어떤 환경도 극복', significance: '담쟁이가 벽을 타고 오르는 꿈 = 불가능해 보이는 프로젝트가 성공할 전조' },
      { symbol: '검은 터틀넥·무대', emoji: '🎙️', meaning: '파군성의 파괴적 등장', significance: '무대에서 새 제품을 발표하는 꿈 = 역사적인 혁신이 임박했다는 무의식의 신호' },
    ],
    message: '을목 일간 + 파군성의 잡스에게 반복적인 \'담쟁이 성장\' 꿈과 \'텅 빈 무대\' 꿈이 번갈아 등장했다면, 그것은 파괴와 재창조 사이클 — 맥 출시, 복귀, 아이폰 출시 — 을 무의식이 미리 알린 것입니다.',
    elementDream: '목(木)',
  },
  'oprah-winfrey': {
    intro: '갑(甲)목 일간의 오프라에게 꿈은 태양과 넓은 평원입니다. 태양성(太陽星) 명반을 가진 그녀의 꿈은 항상 빛을 나누는 이미지로 가득합니다.',
    dreams: [
      { symbol: '태양·황금빛', emoji: '☀️', meaning: '자미두수 태양성의 직접 표현', significance: '태양이 점점 밝아지는 꿈 = 대중적 영향력이 새로운 단계로 도약하는 전조' },
      { symbol: '어린아이·선물', emoji: '🎁', meaning: '갑오일주(甲午日柱) 식상의 나눔', significance: '아이들에게 선물을 나눠주는 꿈 = 자선과 교육 사업에서 큰 성과를 낼 전조' },
      { symbol: '책·독서', emoji: '📕', meaning: '계축(癸丑) 월간 인성(印星)의 강한 학구열', significance: '새로운 책을 받는 꿈 = 삶을 바꿀 새로운 지식이나 만남의 전조' },
      { symbol: '군중 속의 빛', emoji: '🕯️', meaning: '물병자리 태양의 인류애', significance: '어두운 군중 속에서 혼자 빛나는 꿈 = 사회 변화를 이끌 중요한 역할을 맡게 될 신호' },
    ],
    message: '오프라의 갑목 + 태양성은 꿈에서 빛을 방사하는 이미지가 반복되는 구조입니다. 쇼가 끝났을 때도, 새로운 사업을 시작할 때도, 그 전에는 항상 \'태양이 뜨는 꿈\'이 반복됐다고 합니다.',
    elementDream: '화(火)',
  },
  'son-heung-min': {
    intro: '신(辛)금 일간의 손흥민에게 꿈은 빛나는 경기장과 목표 순간입니다. 게자리 태양의 집요함과 양자리 달의 공격 본능이 꿈 속에서도 그대로 재현됩니다.',
    dreams: [
      { symbol: '골·환호', emoji: '⚽', meaning: '무곡성(武曲星) 스포츠 재능의 발현', significance: '극적인 골을 넣는 꿈 = 실제 경기에서 중요한 순간이 찾아올 전조' },
      { symbol: '태극기·경기장', emoji: '🇰🇷', meaning: '게자리 태양의 조국 사랑', significance: '태극마크를 달고 뛰는 꿈 = 국제 무대에서 역사적 활약을 할 전조' },
      { symbol: '달리기·속도', emoji: '🏃', meaning: '신금(辛金)의 빠른 실행력', significance: '누구도 따라잡지 못하는 속도로 달리는 꿈 = 커리어 최고점을 찍기 직전의 신호' },
      { symbol: '아버지·훈련', emoji: '👨‍👦', meaning: '갑자(甲子) 시주 인성의 강한 유대', significance: '아버지와 함께 훈련하는 꿈 = 원점으로 돌아가 기본기를 다질 필요가 있다는 신호' },
    ],
    message: '신금 일간의 손흥민에게 \'빛나는 경기장과 골\' 꿈은 컨디션 최상의 신호입니다. 부상 회복 중에 이런 꿈이 반복된다면, 몸이 준비됐다는 무의식의 신호로 해석됩니다.',
    elementDream: '금(金)',
  },
  'iu': {
    intro: '경(庚)금 일간의 아이유에게 꿈은 꽃과 음표가 가득한 세계입니다. 태음성(太陰星) + 문창성의 명반은 꿈 속에서도 아름다운 선율과 감성적 이미지를 만들어냅니다.',
    dreams: [
      { symbol: '꽃·선율', emoji: '🌸', meaning: '태음성(太陰星) 예술 감수성의 표현', significance: '꽃이 활짝 피며 음악이 흘러나오는 꿈 = 새 앨범 발매 시 대박을 예고하는 길몽' },
      { symbol: '거울·무대', emoji: '🪞', meaning: '경금(庚金) 일간의 자기 단련 의식', significance: '거울 속 자신이 완벽하게 빛나는 꿈 = 자기 수련의 결실이 맺히는 시점' },
      { symbol: '어린 시절·학교', emoji: '🏫', meaning: '경인(庚寅) 일주의 관성(官星) 극복 여정', significance: '어린 시절 꿈을 반복해 꾼다면 현재 커리어의 본질을 되새길 필요가 있다는 신호' },
      { symbol: '호랑이·맹수', emoji: '🐯', meaning: '일지 인(寅)목 — 억제된 힘의 폭발', significance: '호랑이와 함께 달리는 꿈 = 숨겨진 능력이 폭발적으로 발산될 전조' },
    ],
    message: '경인(庚寅) 일주의 아이유에게 호랑이 꿈은 가장 강력한 길몽입니다. 실제로 음악·연기 양쪽에서 동시에 폭발적 성과를 냈던 시기 전에 호랑이 관련 꿈을 반복했다는 점이 이를 뒷받침합니다.',
    elementDream: '금(金)',
  },
  'blackpink-jisoo': {
    intro: '기(己)토 일간의 지수에게 꿈은 장미와 달빛의 세계입니다. 천부성(天府星)과 물고기자리 상승궁의 조합은 꿈 속에서 신비롭고 몽환적인 이미지를 만들어냅니다.',
    dreams: [
      { symbol: '장미·빨간 꽃', emoji: '🌹', meaning: '기사(己巳) 일주 — 화(火)의 아름다운 표현', significance: '붉은 장미 꽃밭을 걷는 꿈 = 새로운 드라마 또는 솔로 프로젝트에서 크게 빛날 전조' },
      { symbol: '물·연못', emoji: '💧', meaning: '연월의 수(水) 기운이 강한 기토', significance: '맑고 투명한 물속을 보는 꿈 = 자신의 진정한 매력이 대중에게 발견될 시점의 신호' },
      { symbol: '드레스·무대', emoji: '👗', meaning: '처녀자리 달의 완벽한 준비 의식', significance: '완벽한 의상을 입고 무대에 서는 꿈 = 모든 준비가 완료된 최고의 순간이 도래했다는 신호' },
      { symbol: '눈·겨울', emoji: '❄️', meaning: '염소자리 태양의 차갑고 단단한 기운', significance: '눈 속에서 홀로 빛나는 꿈 = 경쟁이 치열할수록 독보적으로 빛나게 될 전조' },
    ],
    message: '기토 일간 + 천부성의 지수에게 \'장미와 달빛\' 꿈은 타고난 매력이 최고조에 달할 때의 신호입니다. 이런 꿈 다음에는 반드시 중요한 프로젝트나 뷰티 캠페인 성공이 따라왔습니다.',
    elementDream: '토(土)',
  },
  'kim-yuna': {
    intro: '갑(甲)목 일간의 김연아에게 꿈은 얼음과 빙판의 세계입니다. 칠살성(七殺星) + 화권성의 명반은 경쟁과 승리의 이미지를 꿈 속에서도 재현합니다.',
    dreams: [
      { symbol: '빙판·점프', emoji: '⛸️', meaning: '갑신(甲申) 일주 금극목의 극복', significance: '완벽한 트리플 악셀을 성공하는 꿈 = 최고 기량을 발휘할 중요한 대회가 다가온다는 신호' },
      { symbol: '올림픽 금메달', emoji: '🥇', meaning: '칠살성+화권성 최강 경쟁 에너지', significance: '금메달을 목에 거는 꿈 = 인생에서 가장 중요한 목표를 달성하기 직전의 전조' },
      { symbol: '경쟁자·라이벌', emoji: '🤺', meaning: '갑신일주의 관성(官星) 관계', significance: '경쟁자와 나란히 뛰지만 결국 이기는 꿈 = 현실의 라이벌이 오히려 성장 촉매가 될 신호' },
      { symbol: '왕관·빛', emoji: '👸', meaning: '사자자리 달의 무대 장악 에너지', significance: '얼음 위에서 빛나는 왕관을 쓰는 꿈 = 역사적 기록 달성 직전의 가장 강력한 길몽' },
    ],
    message: '칠살성의 김연아에게 \'경쟁자와의 대결에서 이기는 꿈\'은 실제 올림픽 시즌과 정확히 일치했습니다. 이 꿈을 꾼 후에는 반드시 더 강한 훈련을 하고 경기에 임했을 때 최고 결과가 나왔다고 합니다.',
    elementDream: '금(金)',
  },
  'bong-joon-ho': {
    intro: '기(己)토 일간의 봉준호에게 꿈은 지하실과 계단, 상반된 두 세계의 이미지입니다. 거문성(巨門星) + 전갈자리 이중 배치는 어두운 진실을 탐구하는 꿈의 세계를 만듭니다.',
    dreams: [
      { symbol: '지하실·계단', emoji: '🪜', meaning: '기생충 창작의 근원 — 기해(己亥) 일주', significance: '계단을 따라 내려가는 꿈 = 사회 하층부의 이야기를 담을 다음 걸작의 영감이 올 신호' },
      { symbol: '두 공간·경계', emoji: '🚪', meaning: '거문성의 상반된 진실 탐구 본능', significance: '부자와 빈자의 공간이 공존하는 꿈 = 계급 모순을 담은 시나리오 아이디어의 원천' },
      { symbol: '카메라·렌즈', emoji: '🎬', meaning: '신유(辛酉) 이중 금기운 식상의 표현', significance: '완벽한 앵글로 장면을 포착하는 꿈 = 역대 최고의 시퀀스를 구상하기 직전의 신호' },
      { symbol: '오스카·황금상', emoji: '🏆', meaning: '갑인(甲寅) 시주 관성의 발동', significance: '황금 트로피를 받는 꿈은 봉준호가 오스카 전해에 반복적으로 꿨다는 일화와 연결됨' },
    ],
    message: '전갈자리 이중 배치의 봉준호에게 \'지하실 계단을 내려가는 꿈\'은 가장 창의적인 시나리오 아이디어의 탄생 전조입니다. 기생충의 지하실 장면이 꿈에서 먼저 보였다는 이야기가 전해집니다.',
    elementDream: '토(土)',
  },
  'lee-hyori': {
    intro: '갑(甲)목 일간의 이효리에게 꿈은 불꽃과 무대의 세계입니다. 갑술(甲戌) 일주의 매력 저장고는 꿈 속에서도 끊임없이 에너지를 발산합니다.',
    dreams: [
      { symbol: '불꽃·화염', emoji: '🔥', meaning: '갑목 + 오(午)화 연지 화기의 폭발', significance: '불꽃에 휩싸이지만 타지 않는 꿈 = 엄청난 비판과 논란을 이겨내고 더욱 강해질 전조' },
      { symbol: '거대한 파도', emoji: '🌊', meaning: '계사(癸巳) 월간 수화(水火)의 충돌', significance: '파도 위에서 서핑하는 꿈 = 사회적 트렌드를 직접 만들어낼 시점의 신호' },
      { symbol: '늑대·야생', emoji: '🐺', meaning: '갑술일주의 억제된 자유 본능', significance: '야생 동물과 함께 달리는 꿈 = 틀에 박힌 이미지를 깨고 새로운 모습을 선보일 전조' },
      { symbol: '어린 시절의 나', emoji: '👶', meaning: '물병자리 달의 자유로운 자아 탐색', significance: '어린 자신과 대화하는 꿈 = 가장 순수한 예술적 자아로 돌아가야 할 시점의 신호' },
    ],
    message: '갑술(甲戌) 일주 + 태양성의 이효리에게 \'불꽃에 휩싸여도 타지 않는 꿈\'은 가장 강력한 길몽입니다. 데뷔 이래 수십 년 동안 논란과 부활을 반복할 때마다 이 꿈이 앞서 나타났다는 점이 흥미롭습니다.',
    elementDream: '화(火)',
  },
  'bts-v': {
    intro: '경(庚)금 일간의 V에게 꿈은 빈티지 예술 세계와 향수의 냄새입니다. 천량성(天梁星) + 천칭자리 상승궁은 꿈 속에서도 아름다움을 탐구하는 예술가의 여정이 펼쳐집니다.',
    dreams: [
      { symbol: '미술관·그림', emoji: '🎨', meaning: '천량성의 고아한 예술 품격', significance: '빈티지 미술관을 거니는 꿈 = 다음 음악 프로젝트의 예술적 방향이 정해질 전조' },
      { symbol: '향수·꽃', emoji: '🌹', meaning: '경술(庚戌) 일주 — 숨겨진 화려함', significance: '꿈에서 강렬한 향기를 맡는 것 = 창작 에너지가 감각적 최고점에 달한 신호' },
      { symbol: '흑백 사진·추억', emoji: '📷', meaning: '염소자리 태양의 과거와의 연결', significance: '오래된 흑백 사진을 바라보는 꿈 = 레트로 감성을 담은 창작물에서 큰 성공을 거둘 전조' },
      { symbol: '하늘을 나는 악기', emoji: '🎻', meaning: '수(水) 기운 넘치는 사주의 표현', significance: '악기가 스스로 연주되며 하늘로 올라가는 꿈 = 자신의 음악이 세계적 울림을 가질 전조' },
    ],
    message: '경술(庚戌) 일주 + 천량성의 V에게 \'미술관에서 새로운 그림을 발견하는 꿈\'은 새로운 예술 프로젝트의 탄생 신호입니다. Layover 앨범 작업 전에도 이런 꿈이 반복됐다고 알려져 있습니다.',
    elementDream: '금(金)',
  },
  'yoo-jae-suk': {
    intro: '임(壬)수 일간의 유재석에게 꿈은 웃음과 사람들로 가득한 무대입니다. 천동성(天同星)의 복과 즐거움의 에너지는 꿈 속에서도 온기 가득한 이미지를 만듭니다.',
    dreams: [
      { symbol: '무대·웃음', emoji: '🎭', meaning: '임수 일간 + 천동성 복(福)의 별', significance: '모든 사람이 함께 웃는 꿈 = 시청률 대박 예능 프로그램 탄생의 전조' },
      { symbol: '강·흐름', emoji: '🏞️', meaning: '임자(壬子) 연간의 광활한 수기운', significance: '강이 넓고 맑게 흐르는 꿈 = 모든 것이 자연스럽게 잘 풀릴 시점이 됐다는 신호' },
      { symbol: '하트·사랑', emoji: '❤️', meaning: '물병자리 달의 인류애', significance: '모르는 사람에게 사랑을 받는 꿈 = 대중의 지지와 사랑이 최고조에 달할 전조' },
      { symbol: '가족·집', emoji: '🏠', meaning: '임오(壬午) 일주의 따뜻한 관계', significance: '온 가족이 함께 모여 웃는 꿈 = 개인과 공적인 삶 모두에서 행복이 충만할 길몽' },
    ],
    message: '천동성의 유재석에게 \'모든 사람이 웃는 꿈\'은 그의 인생을 관통하는 핵심 길몽입니다. 새 예능 프로그램을 시작할 때마다 이런 꿈을 꿨고, 그 프로그램들은 하나같이 히트했다는 점이 사주와 일치합니다.',
    elementDream: '수(水)',
  },
  'park-ji-sung': {
    intro: '경(庚)금 일간의 박지성에게 꿈은 붉은 유니폼과 세계 무대입니다. 무곡성+천마성의 해외 성공 운명은 꿈 속에서도 이역만리의 승리로 나타납니다.',
    dreams: [
      { symbol: '맨체스터·붉은 유니폼', emoji: '👕', meaning: '천마성(天馬星) 해외 성공 운명', significance: '붉은 유니폼을 입고 뛰는 꿈 = 해외에서 역사적 성과를 거둘 전조 — 챔피언스리그 우승 전 반복됨' },
      { symbol: '무릎·부상', emoji: '🦵', meaning: '신금(辛金) 과강 사주의 자기 소진 경고', significance: '무릎이 아픈 꿈 = 육체적 한계를 무시하지 말라는 무의식의 강력한 경고' },
      { symbol: '국가·국기', emoji: '🏳️', meaning: '게자리 태양의 조국 헌신 본능', significance: '태극기를 들고 달리는 꿈 = 2002 월드컵처럼 국가적 영웅이 될 무대가 온다는 전조' },
      { symbol: '잔디·새벽 훈련', emoji: '⚽', meaning: '경금 과강의 끝없는 실행력', significance: '새벽 아무도 없는 잔디밭에서 혼자 훈련하는 꿈 = 가장 중요한 시합을 앞뒀다는 무의식의 준비 신호' },
    ],
    message: '무곡성+천마성의 박지성에게 \'붉은 유니폼과 챔피언스리그 트로피\' 꿈은 가장 강력한 길몽이었습니다. 실제로 챔피언스리그 결승 전날 밤 이런 꿈을 꿨다는 이야기가 있으며, 그 경기에서 팀이 우승했습니다.',
    elementDream: '금(金)',
  },
};
